import { API } from "@memberpoint/mp-frontend-core";

/**
 * A Manager that provides an interface to manager clip profiles.
 */
export class ClipProfileManager extends API.SimpleAPIBaseManager {
  /**
   * Get a list of all non-deleted clip profiles
   *
   * @returns {Promise<SimpleAPIResponse | SimpleAPIResponse[]>}
   */
  getClipProfiles() {
    let url = "/app/clip-profiles";
    return this.apiCall({ url });
  }

  /**
   * Get a specific clip profiles by its UUID
   *
   * @param id
   * @returns {Promise<SimpleAPIResponse | SimpleAPIResponse[]>}
   */
  getClipProfilesById(id) {
    let url = `/app/clip-profiles/${id}`;
    return this.apiCall({ url });
  }

  /**
   * Update a specific clip profile by its UUID
   *
   * @param id
   * @param data
   * @returns {Promise<SimpleAPIResponse | SimpleAPIResponse[]>}
   */
  updateClipProfile(id, data) {
    let url = `/app/clip-profiles/${id}`;
    data = { attributes: data };
    return this.apiCall({ url, method: "PUT", data });
  }

  /**
   * Add a new clip profile.
   *
   * @param data
   * @returns {Promise<SimpleAPIResponse | SimpleAPIResponse[]>}
   */
  addClipProfile(data) {
    let url = `/app/clip-profiles`;
    data = { attributes: data };
    return this.apiCall({ url, method: "POST", data });
  }
}
